<div class="list-wrapper">
  <form-control-model [defaultHeight]="25" [columns]="columns" [group]="group" [model]="model"> </form-control-model>
<kgrid
  [apiName]="apiName"
  [label]="label"
  [name]="apiName"
  [areaName]="areaName"
  pathPreFix="HRM"
  [actions]="actions"
  [actionTregger]="onActionClick"
  reportName="HrmDiskFormatList"
  [inputEditorform]="inputEditorform">
</kgrid>
</div>

